import { IWindowSize, useWindowSize } from '../../../hooks/useWindowSize';
import { IWorkWithUsProps } from './intrerfaces';
import Image from 'next/image';
import { imageSerializer } from '../../../utils/imageSerializer';
import {
  SectionContainer,
  SectionContainerBottomLeft,
  SectionContainerBottomRight,
  SectionContainerDescription,
  SectionContainerImage,
  SectionContainerTitle,
  SectionContainerTopLeft,
  SectionContainerTopRight,
  Title,
  Wrapper,
} from './workingWithUs.styles';

export const WorkingWithUs = ({
  title,
  topLeftTitle,
  topLeftDescription,
  topRightTitle,
  topRightDescription,
  bottomLeftTitle,
  bottomLeftDescription,
  bottomRightTitle,
  bottomRightDescription,
  contentImage,
  contentImageXs,
  titleAs,
}: IWorkWithUsProps): JSX.Element => {
  const { width }: IWindowSize = useWindowSize();

  return (
    <Wrapper>
      <Title as={titleAs}>{title}</Title>
      <SectionContainer>
        <SectionContainerTopLeft>
          <SectionContainerTitle>{topLeftTitle}</SectionContainerTitle>
          <SectionContainerDescription>
            {topLeftDescription}
          </SectionContainerDescription>
        </SectionContainerTopLeft>
        <SectionContainerTopRight>
          <SectionContainerTitle>{topRightTitle}</SectionContainerTitle>
          <SectionContainerDescription>
            {topRightDescription}
          </SectionContainerDescription>
        </SectionContainerTopRight>
        <SectionContainerBottomLeft>
          <SectionContainerTitle>{bottomLeftTitle}</SectionContainerTitle>
          <SectionContainerDescription>
            {bottomLeftDescription}
          </SectionContainerDescription>
        </SectionContainerBottomLeft>
        <SectionContainerBottomRight>
          <SectionContainerTitle>{bottomRightTitle}</SectionContainerTitle>
          <SectionContainerDescription>
            {bottomRightDescription}
          </SectionContainerDescription>
        </SectionContainerBottomRight>
        <SectionContainerImage>
          {width! > 1200 && <Image {...imageSerializer(contentImage)} />}

          {width! <= 1200 && <Image {...imageSerializer(contentImage)} />}
        </SectionContainerImage>
      </SectionContainer>
    </Wrapper>
  );
};
